define('GameDayCore/GDModel/ValueObjects/Game/GameFile',['require','exports','module','../ValueObjectFactory','./GameFileStadium','./GameFileTeam'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(GameFile);

	function GameFile($data) {
		var vo = VO.ensureVO(this, GameFile),
			data = $data,
			GameFileStadium = require('./GameFileStadium'),
			GameFileTeam = require('./GameFileTeam');

		vo.type = data.type || "";
        vo.gameday_sw = data.gameday_sw || "";
        vo.local_game_time = data.local_game_time || "";
        vo.game_time_et = data.game_time_et || "";
        vo.day_or_night = setDayNightValue(data);
        vo.game_pk = data.game_pk || "";
        vo.home = new GameFileTeam( (data.team[0].type == "home") ? data.team[0] :  data.team[1]);
        vo.away = new GameFileTeam( (data.team[0].type == "home") ? data.team[1] :  data.team[0]);
        vo.stadium = new GameFileStadium(data.stadium);
	}

	function setDayNightValue(data) {
		var hour = parseInt(data.local_game_time.substr(0, 2)),
			min = parseInt(data.local_game_time.substr(3, 2));

		return ((hour > 18 || hour < 5) || (hour === 6 && min > 30)) ? "night" : "day";
	}

	return GameFile;
});
